import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';
import memoizeOne from 'memoize-one';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import PasswordValidationStatus from '../../../components/passwordvalidationstatus';
import PhoneNumber from '../../../components/phonenumber';
import { validatePassword } from '../../utils';

const pwdValidations = [
	'min8Chars',
	'upperLower',
	'specialChars'
];

const getPasswordValidationStatus = memoizeOne(pwd => {
	return validatePassword(pwd);
});

export default class PasswordForm extends React.PureComponent {
	render() {
		const {data, setPassword, setProperty} = this.props;
		const {pwd1, pwd2, passwordVerificationError} = data.toJS();
		const validationStatus = getPasswordValidationStatus(pwd1);

		return (
			<>
				<h1>{getPhrase('passwordCreation')}</h1>
				<SimpleMessage>{getPhrase('createYourPortalPassword')}</SimpleMessage>
				<SimpleMessage>{getPhrase('passwordMustMeetTheseCriteria')}:</SimpleMessage>
				<PasswordValidationStatus validations={pwdValidations} validationStatus={validationStatus} />
				<Form vertical onAction={setPassword} key="unamePwd">
					<FormItem label={getFormItemLabel('password')}>
						<TextInput
							password
							value={pwd1 || ''}
							onChange={value => {
								setProperty('pwd1', value);
							}}
						/>
					</FormItem>
					<FormItem label={getFormItemLabel('passwordVerification')} error={passwordVerificationError}>
						<TextInput
							value={pwd2 || ''}
							password
							onChange={value => {
								setProperty('pwd2', value);
							}}
						/>
					</FormItem>
					<Button
						text={getPhrase('submit')}
						onAction={setPassword}
						disabled={!validationStatus.valid || pwd1 !== pwd2}
					/>
				</Form>
				<div className="footer">
					<span className="text">{getPhrase('needAdvice')}</span>
					<PhoneNumber preset="intergram" />
				</div>
			</>
		);
	}
}

const SimpleMessage = styled.div`
	color: ${props => props.theme.disabledTextColor};
	font-size: 16px;
	line-height: 30px;
	font-weight: 400;
	margin-top: 12px;
	margin-bottom: 12px;
`;
